import React from 'react'
import ContactHeroSection from './ContactHeroSection'
import ContactSection from './ContactSection'
import LocationsSection from './LocationsSection'
import MoreLocationsSection from './MoreLocationsSection'
import ContactBookingSection from './ContactBookingSection'

const ContactUsPage = () => {
  return (
    <div>
        <ContactHeroSection/>
        <ContactBookingSection/>
        <ContactSection/>
        <LocationsSection/>
        <MoreLocationsSection/>
    </div>
  )
}

export default ContactUsPage